import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup } from 'react-bootstrap'
import { inject, observer } from "mobx-react"
import ColorPicker from '../../ColorPicker'

@inject("store")
@observer
export default class ColorPickerField extends React.Component {
  render() {
    const { store, field } = this.props
    const { name, uuid, hint, required } = field
    const instance = this.props.instance || 0
    const value = store.valueFor(uuid, "text", instance) || ""
    const errorMessage = store.errorFor(uuid, "text", instance)

    return (
      <FormGroup>
        <Form.Label htmlFor={`${uuid}-${instance}`}>{ required ? "*" : "" } {name}</Form.Label>
        <div className="only-pdf">
          <div style={{
            display: 'inline-block',
            width: '20px',
            height: '20px',
            backgroundColor: value || '#ffffff',
            border: '1px solid #ccc',
            marginRight: '8px',
            verticalAlign: 'middle'
          }}></div>
          { value }
        </div>
        <div className="no-pdf">
          <ColorPicker
            id={`color-picker-${uuid}-${instance}`}
            value={value}
            onChange={color => store.setValueFor(uuid, "text", instance, color)}
            disabled={!store.editable}
          />
        </div>
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{errorMessage}</Form.Control.Feedback> }
        { hint && <Form.Text muted>{hint}</Form.Text > }
      </FormGroup>
    )
  }
}
